import SubHeader from '../../../../../../components/SubHeader/SubHeader';
import globalColors from '../../../../../../styles/_colors.scss';
import s from '../../../../SchoolPages.module.scss';
import BreadCrumbs from '../../../../../../components/Breadcrumbs/Breadcrumbs';
import IntroMessage from '../../../../components/IntroMessageAlt/IntroMessageAlt';
import BrandHero from './components/brand-hero-kindergarten-work.webp';
import Media from './components/contest-kindergarten.webp';
import { useGetWorks } from '../../../../../../api/work';
import { useEffect, useMemo, useState } from 'react';
import { useAppSelector } from '../../../../../../redux/hooks';
import ContestBanner from '../../../../components/ContestBanner/ContestBanner';
import ChildrenWorks from '../../../../components/ChildrenWorks/ChildrenWorks';
import SocialMedia from '../../../../../../components/SocialMedia/SocialMedia';
import { Divider } from '../../../../../../components/Divider/Divider';
import SingleWorkView from '../../../../components/SingleWorkView/SingleWorkView';
import ViewComment from '../../../../components/ViewComment/ViewComment';
import AdditionalWorksImg from '../../../../../SchoolPages/components/AdditionalMaterials/additional-works-kindergarten.webp';
import { SchoolType, useGetContests } from '../../../../../../api/contest';
import { getValidContests } from '../../../../../../utils/api/contests';
import { motion } from 'framer-motion';
import { useSchoolParams } from '../../../../../../utils/api/school';
import { useMediaQuery } from 'usehooks-ts';

const GroupWorkPage = () => {
  const params = useSchoolParams();
  const works = useGetWorks({
    school: params.schoolId,
    grade: params.gradeId,
  });
  const [resWorks, setResWorks] = useState<any>(null);
  useEffect(() => {
    const { data } = works;
    if (data?.length >= 0) {
      setResWorks(data);
    }
  }, [works]);

  const user = useAppSelector((state) => state.user);
  const loggedIn = !!user.userData;

  const contests = useGetContests(SchoolType.Kindergarten);

  const validContest = useMemo(() => {
    return getValidContests(Object.values(contests.data))[
      SchoolType.Kindergarten
    ];
  }, [contests]);

  const workId = resWorks?.find(
    (child: any) => child.id.toString() === params.workId?.toString()
  )?.author;

  const mobile = useMediaQuery('(max-width: 768px)');

  return (
    <motion.div
      initial='hidden'
      animate='visible'
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <SubHeader color={globalColors.blue4} />
      <BreadCrumbs
        groups={resWorks?.[0]?.school?.name}
        group={resWorks?.[0]?.grade?.name}
        workId={workId}
      />
      <IntroMessage
        h1='Kreatywność.
      Rozwój i nauka.
      Zabawa.'
        image={BrandHero}
        imgStyle={{
          width: mobile ? '100%' : '55%',
          height: mobile ? 'auto' : '610px',
        }}
      />
      <ContestBanner
        loading={contests.isLoading}
        imgStyle={{
          width: mobile ? '100%' : '30%',
          height: mobile ? '200px' : '430px',
          objectFit: 'contain',
          padding: '2rem',
        }}
        media={Media}
        data={validContest}
      />
      {resWorks?.[0] && (
        <SingleWorkView
          isElementary={false}
          showAdditionalMaterials={true}
          additionalWorksImg={AdditionalWorksImg}
          additionalWorksTitle={'Materiały dydaktyczne do nauki'}
        />
      )}
      <ViewComment />
      <div className={s.divider}>
        <Divider height={'2px'} backgroundColor={'#89939E'} />
      </div>
      <ChildrenWorks
        params={{
          school: params.schoolId,
          grade: params.gradeId,
        }}
        imgStyle={{ width: '100%', height: '172px' }}
        loggedIn={loggedIn}
      />
      <SocialMedia />
    </motion.div>
  );
};

export default GroupWorkPage;
